import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { UserRoleService } from '../user-role.service';
import {
    UserRoleActionTypes,
    SetUserRole,
    LoadUserRoles,
    Reset
} from './actions';
import {
    mergeMap,
    map,
    catchError,
    switchMap,
    tap,
    filter,
    take
} from 'rxjs/operators';
import * as fromShared from '../../shared';
import { IUserRole } from '../IUserRole';
import { LoggingService } from '../../shared/services/logging';
import { UserRoleEnum } from '../../user-info';
import { StateService } from '@uirouter/core';
import { getUserInfo } from '../../user-info/store/user.reducer';
import { RegistrationPrefetchService } from '../../data-services/registration';
import { of } from 'rxjs';
@Injectable()
export class UserRoleEffects {
    constructor(
        private actions$: Actions,
        private userRoleService: UserRoleService,
        private log: LoggingService,
        private ss: StateService,
        private store: Store,
        private registrationPrefetch: RegistrationPrefetchService
    ) {}

    LoadUserRoles$ = createEffect(() =>
        this.actions$.pipe(
            ofType<LoadUserRoles>(UserRoleActionTypes.LoadUserRoles),
            switchMap(action =>
                this.userRoleService.getUserRoles().pipe(
                    map(roles => new SetUserRole(roles)),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
    SetUserRole$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType<SetUserRole>(UserRoleActionTypes.SetUserRole),
                switchMap(action =>
                    this.store.pipe(
                        select(getUserInfo),
                        filter(info => !!info?.EmployeeListID),
                        take(1),
                        switchMap(userInfo => {
                            const isAdmin = action.payload.some(
                                x =>
                                    x.RoleGroupID === UserRoleEnum.Administrator
                            );
                            if (!isAdmin) {
                                return of({ action, userInfo });
                            }

                            return this.registrationPrefetch.ensureLoaded$().pipe(
                                map(() => ({ action, userInfo }))
                            );
                        })
                    )
                ),
                tap(({ action, userInfo }) => {
                    this.log.verbose({ type: 'SetUserGroups$', action, userInfo });

                    if (
                        fromShared.hasInitialRouteRedirect(
                            userInfo?.Initialroutename
                        )
                    ) {
                        this.log.verbose({
                            type: 'SetUserGroups$',
                            message:
                                'Initial route set; login redirect handled in auth.effects'
                        });
                        return;
                    }

                    if (
                        action.payload.some(
                            x => x.RoleGroupID === UserRoleEnum.Administrator
                        )
                    ) {
                        this.log.verbose({
                            type: 'SetUserGroups$',
                            message:
                                'user is admin, redirecting to register (user-role.effects)'
                        });
                        this.ss.go('register', {
                            supercede: true
                        });
                    }
                })
            ),
        { dispatch: false }
    );
}
